'use strict';
angular.module('cimerFrontEndApp').controller('CreateMentorshipSurveyCtrl', ['$scope', '$http', '$location', 'Session', 'ApiUrl', function ($scope, $http, $location, Session, ApiUrl) {

    var sessionObject = Session.getSessionObject();
    if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isEventCreator)) {
        $location.url('/');
        return;
    }

    $scope.grant = {
        startDate: null,
        endDate: null,
        organization: '',
        location: '',
        type: '',
        modality: '',
        competencies: null,
        facilitatorNames: '',
        duration: ''
    };
    $scope.grantCategories = {};
    $scope.saving = false;
    $scope.formSubmitted = false;

    // Get data for drop downs
    $http.get(ApiUrl.url('/Grant/') + 'GetGrantCreationOptions').then(function (response) {
        $scope.grantCategories = response.data;
    });

    $scope.saveGrant = function () {
        $scope.formSubmitted = true;
        if (!this.grantForm.$valid) {
            return;
        }

        $scope.saving = true;
        var data = {
            StartDate: $scope.grant.startDate,
            EndDate: $scope.grant.endDate,
            Organization: $scope.grant.organization,
            Location: $scope.grant.location,
            TypeID: getKeyFromValue($scope.grantCategories.Types, $scope.grant.type),
            TypeName: $scope.grant.type,
            ModalityID: getKeyFromValue($scope.grantCategories.Modalities, $scope.grant.modality),
            ModalityName: $scope.grant.modality,
            Competencies: getCompetenciesForSave(),
            FacilitatorNames: $scope.grant.facilitatorNames,
            Duration: $scope.grant.duration
        };
        $http.post(ApiUrl.url('/Grant/') + 'CreateGrantCIMERTFI', data).then(function (response) {
            if (response.data && response.data !== -1) {
                $scope.saving = false;
                // redirect to select survey
                $location.path('customSurvey/' + response.data);
            }
        }, function (err) {
            $location.path('error');
        });
    };

    $scope.clearGrantForm = function () {
        $scope.grant = {
            startDate: null,
            endDate: null,
            organization: '',
            location: '',
            type: null,
            modality: null,
            competencies: null, // take all the submitted values out of this array
            facilitatorNames: '',
            duration: ''
        };
        // Set all the model data for competencies to unselected
        for (var i = 0; i < $scope.grantCategories.Competencies.length; i++) {
            $scope.grantCategories.Competencies[i].Selected = false;
        }
        $scope.formSubmitted = false;
    };

    $scope.updateCompetencies = function () {
        // clear everything from the competencies array
        $scope.grant.competencies = [];
        // Add everything that is selected
        for (var i = 0; i < $scope.grantCategories.Competencies.length; i++) {
            var competency = $scope.grantCategories.Competencies[i];
            if (competency.Selected) {
                $scope.grant.competencies.push(competency);
            }
        }
    };

    var getCompetenciesForSave = function () {
        var competencyIDs = [];
        if ($scope.grant.competencies == null) {
            return competencyIDs;
        }
        for (var i = 0; i < $scope.grant.competencies.length; i++) {
            competencyIDs.push($scope.grant.competencies[i].CompetencyID);
        }
        return competencyIDs;
    };

    var getKeyFromValue = function (dict, value) {
        for (let prop in dict) {
            if (dict[prop] === value) {
                return parseInt(prop, 10);
            }
        }
    };
}]);
